import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group, ImageMantine, Modal, Stack, Text } from 'ui';

import { holidayDonateModalAtom } from '../atoms';

const ModalContent = () => {
  const navigate = useNavigate();
  return (
    <Stack gap={'xl'}>
      <Stack gap={'xs'}>
        <Text fz={24} fw={600}>
          Donate to 1 or more causes of your choice!
        </Text>
        <Text c={'gray.6'} fz={14} fw={400}>
          Every donation you make to a cause, Givebacks will donate $5 on your behalf for kids in
          foster care.
        </Text>
      </Stack>

      <ButtonMantine onClick={() => navigate('/causes')}>Explore Causes & Donate</ButtonMantine>
    </Stack>
  );
};
const DonateModal = () => {
  const [opened, setDonateModal] = useAtom(holidayDonateModalAtom);
  return (
    <Modal
      opened={opened}
      onClose={() => setDonateModal(false)}
      title={
        <Group justify="center" style={{ flexGrow: 1, marginLeft: 'auto', marginRight: 'auto' }}>
          <ImageMantine
            src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/coins.png"
            w={64}
          />
        </Group>
      }
      styles={{ title: { width: '100%' } }}
    >
      <ModalContent />
    </Modal>
  );
};

export { DonateModal };
